import React, { useState } from 'react';
import { Steps } from 'antd';
import ResourceCard from './ResourceCard';
import SectionReviewBlock from './SectionReviewBlock';
import Button from '@common/Button';
import { ArrowBackRounded } from '@mui/icons-material';

const RESOURCES = [
    { key: 'textbookContent', icon: '📖', label: 'Textbook Section Content', description: 'Worked examples and explanations from the textbook' },
    { key: 'exercise',        icon: '✏️',  label: 'Exercise',                 description: 'Structured practice exercises from the textbook' },
    { key: 'questions',       icon: '❓', label: 'Questions',                description: 'Individual practice questions' },
    { key: 'quiz',            icon: '📋', label: 'Quiz',                     description: 'Short knowledge-check quizzes' },
    { key: 'walkthroughs',    icon: '🔍', label: 'Walkthroughs',             description: 'Interactive step-by-step guides' },
    { key: 'extras',          icon: '🎮', label: 'Scorcher, Desmos and Games', description: 'Extension challenges and interactive activities' },
    { key: 'videos',          icon: '🎬', label: 'Videos',                   description: 'Lesson explainer videos' },
    { key: 'worksheets',      icon: '📄', label: 'Worksheets',               description: 'Printable worksheets for classwork or homework' },
];



const STEP_ITEMS = [
    { title: 'Choose type' },
    { title: 'Select content' },
];

const AddSectionDrawer = ({ conceptId }) => {
    const [step, setStep] = useState(0);
    const [selectedKey, setSelectedKey] = useState(null);

    const handleSelectType = (key) => {
        setSelectedKey(key);
        setStep(1);
    };

    const handleBack = () => {
        setStep(0);
        setSelectedKey(null);
    };

    return (
        <div className="ch-lesson-planner-drawer ch-add-section-drawer">
            <h3 className="ch-lesson-planner-drawer-title">Add Section</h3>
            <Steps current={step} size="small" items={STEP_ITEMS} className="ch-add-section-steps" />

            {step === 0 && (
                <div className="ch-add-section-type-list">
                    {RESOURCES.map(resource => (
                        <ResourceCard
                            key={resource.key}
                            resource={resource}
                            checked={false}
                            onChange={() => handleSelectType(resource.key)}
                        />
                    ))}
                </div>
            )}

            {step === 1 && (
                <>
                    <div className="ch-add-section-review-content">
                        <SectionReviewBlock sectionKey={selectedKey} conceptId={conceptId} />
                    </div>
                    <div className="ch-add-section-footer">
                        <Button type="outline" icon={<ArrowBackRounded />} onClick={handleBack}>Back</Button>
                        <div className="ch-add-section-footer-spacer" />
                        <Button type="primary" onClick={() => {}}>Add to Plan</Button>
                    </div>
                </>
            )}
        </div>
    );
};

export default AddSectionDrawer;
